export default __webpack_public_path__ + "static/media/portfolio1.efbc3a16.png";